export default "__VITE_ASSET__CyUky9EZ__"